import { Component, OnInit } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { LunexService } from '../services/lunex.service';
import * as loginReducers from "@modules/login/reducers";
import { ROLES } from '@root/resources/enums/role.enum';
import { Store, select } from '@ngrx/store';
import * as adminReducer from '@modules/super-admin/reducers';

@Component({
  selector: 'edex-vcard-trnx',
  templateUrl: './vcard-trnx.component.html',
  styleUrls: ['./vcard-trnx.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class VcardTrnxComponent implements OnInit {

  dataSource:any[]=[];
  time:any
  public user$ = this.store.pipe(select(loginReducers.getUser));
  public merchants$ = this.store.pipe(select(adminReducer.getMerchants));

  columnsToDisplay:string[] = ['orderId','customer', 'transactionAmount', 'vCardNo', 'stellarToken', 'transactionId', 'createdAt'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay,'paymentProcessorType', 'expand'];
  user: any;
  constructor(private lunexService: LunexService,private store: Store<adminReducer.State>,) { 
    
    this.user$.subscribe((user) => {
      this.user = user;
    });
    if(this.user.role == ROLES.SALES_AGENT) {
      this.getSAmerchantsTransactions()
    } else if(this.user.role == ROLES.SUPER_ADMIN) {
      this.getTransactions();
    }
  }

  ngOnInit() {
  }

  getTransactions() {
    this.lunexService.getvCardTransactions().subscribe(res => {
      if(res && res.status) {
        res.result.map(item => {
          item.vCardNo = item.vCardNo || '-'
          let dt = new Date(item.createdAt);
          item.createdAt = `${dt.getFullYear()}-${dt.getMonth()+1}-${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`
          let itemd = this.lunexService.fetchCutomerDetails(item);
          item.resJson = itemd.response;
          item.address = itemd.address;
          item.customer = itemd.customer;
          item.stallerResponse = (item.stallerResponse) ? JSON.parse(item.stallerResponse) : null;
          return item;
        })
        this.dataSource = res.result;
      }
    })
  }

  getSAmerchantsTransactions() {
    console.log(this.user._id);
    let body = {
      "user_id":this.user._id
    }
    this.lunexService.getSAmerchantsTransactions(body).subscribe(res => {
      if(res && res.ok) {
        res.result.map(item => {
          item.vCardNo = item.vCardNo || '-'
          let dt = new Date(item.createdAt);
          item.createdAt = `${dt.getFullYear()}-${dt.getMonth()+1}-${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`
          let itemd = this.lunexService.fetchCutomerDetails(item);
          item.resJson = itemd.response;
          item.address = itemd.address;
          item.customer = itemd.customer;
          item.stallerResponse = (item.stallerResponse) ? JSON.parse(item.stallerResponse) : null;
          return item;
        })
        this.dataSource = res.result;
      }
    })
  }

}
